// extracted by mini-css-extract-plugin
module.exports = {"masonry":"Masonry_masonry__2IBrO","column":"Masonry_column__29N8c"};